var cov_nkew27cjy = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/styles/index.ts",
      hash = "0fca475d027ff54276677d0d52631ca093e1537b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 5,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var tableLess = {};
import genaration from '../../utils/classname';
export var tableClass = (cov_nkew27cjy.s[0]++, genaration(tableLess, 'table'));